export type AnalyticsSendTo = 'ga' | 'gtag';

export interface AnalyticsOptions {
  eventCategory: string;
  eventLabel?: string;
  eventAction: string;
}

export enum EAnalyticsEventsName {
  FreeCoinsCollected = 'free_coins_collected',
  AddedCoins = 'added_coins',
  AddCoinsPaymentError = 'add_coins_payment_error',
  ConvertedCoins = 'converted_coins',
  ConvertedOfflineCoins = 'converted_offline_coins',
  ConvertCoinsError = 'convert_coins_error',
  SigninSuccess = 'signin_success',
  SignupLocalSuccess = 'signup_success',
  SignupProviderSuccess = 'signup_provider_success',
  EmailConfirmed = 'email_confirmed',
  CreditCardRemoved = 'credit_card_removed',
  CouponRedeemed = 'coupon_redeemed',
  CreditCardAdded = 'credit_card_added',
  GiftSent = 'gift_sent',
  OfferSaved = 'offer_saved',
  GotLoyaltyCoins = 'got_loyalty_coins',
  NewExplorerOrder = 'Explore | Order Sections',
  DashboardBusinessSignup = 'Business Sign up',
  DashboardNewConsumerAcquired = 'New Consumer Acquired 2',
  DashboardFreeCoinsMinted = 'Free Coins Minted',
  DashboardRewardCoinsMinted = 'Reward Coins Minted 3',
  DashboardFiatCoinsMinted = 'Fiat Coins Minted 2',
  DashboardGiftCoinsMinted = 'Gift Coins Minted',
  DashboardCouponGiven = 'Coupon Given',
  DashboardConsumerRedemption = 'Consumer Redemption 2',
  DashboardUserSignup = 'User Sign up',
  DashboardAwardCoinsMinted = 'Award Coins Minted',
  DashboardFreeCoinsCampaignCreated = 'Free Coins Campaign Created',
  DashboardFreeCoinsCampaignEdited = 'Free Coins Campaign Edited',
  DashboardOfferCreated = 'Offer Created',
  DashboardOfferEdited = 'Offer Edited',
  DashboardSocialMediaSaved = 'Social Media Saved',
  DashboardBusinessAutomaticReport = 'Business Automatic Report',
  DashboardSellCoinsStatus = 'Sell Coins status',
  DashboardSellCoinsActivated = 'Sell Coins Activated',
  DashboardSellCoinsDeactivated = 'Sell Coins Deactivated',
  DashboardWithdraw = 'Withdraw',
  DashboardStripeConnected = 'Stripe connected',
  DashboardRewardProgramCreated = 'Reward Program Created',
  DashboardRewardProgramEdited = 'Reward Program Edited',
  DashboardNPOCoinCreated = 'NPO Coin Created',
  DashboardNPOCoinEdited = 'NPO Coin Edited',
  DashboardNPOCoinNameError = 'NPO Coin name error',
  DashboardInactiveCustomerSettings = 'Inactivity Consumers Edited',
  SendCoinsSent = 'sendcoins_sent',
  DashboardSendCoinsCoinsMinted = 'Send Coins Minted',
  DashboardIncreaseExternalRedeemCounter = 'Offer External Redeem',
  DashboardBusinessDeactivated = 'Business Deactivated',
  DashboardBusinessReactivated = 'Business Reactivated',
  DashboardTipFinished = 'Tip Finished',
  DashboardRewardBonusCoinsMinted = 'Reward Bonus Coins Minted',
  DashboardBusinessNewOwner = 'Business New Owner',
  DashboardBillingSubscriptionActivated = 'Billing Subscription Activated',
  DashboardBillingSubscriptionDeactivated = 'Billing Subscription Deactivated',
  DashboardBillingSubscriptionReactivated = 'Billing Subscription Reactivated',
  DashboardBillingSubscriptionLocationAdded = 'Billing Location Added',
  DashboardBillingSubscriptionLocationRemoved = 'Billing Location Removed',
  DashboardBillingCoinsMinted = 'Billing Coins Minted',
  DashboardPendingRewardCoinsMinted = 'Pending Reward Coins Minted'
}
